
import React, { Component } from 'react'
import { Button, Message, Icon } from 'semantic-ui-react'
import { Consumer, MyContext } from '../../../../context/Context'
import { twitterProvider, firebase } from '../../../../services/Store'
// import { withFirebase } from '../../../services';

class SignInTwitterBase extends Component {
  constructor() {
    super();
    this.provider = twitterProvider;
    this.state = { error: null };
  }

  onSubmit = (dispatch, e) => {
    e.preventDefault();
    firebase.auth().signInWithPopup(this.provider).then(function (result) {
    console.log(result)


    // let expDate = null;
    // expDate = new Date(new Date().getTime() + result.data.expiresIn * 1000);
    // localStorage.setItem('token', result.credential.accessToken);
    // localStorage.setItem('expDate', expDate);
    // localStorage.setItem('userId', result.data.localId);


        // let expDate = null;
    // expDate = new Date(new Date().getTime() + result.data.expiresIn * 1000);
    const expiresAt = JSON.stringify(result.expiresIn * 1000 + Date.now());
    localStorage.setItem("expires_at", expiresAt);

    localStorage.setItem('token', result.credential.accessToken);
    localStorage.setItem('expDate', expiresAt);
    localStorage.setItem('userId', result.user.uid);

    dispatch({
      type: 'AUTH_LOGIN',
      // payload: { token: result.data.idToken, localId: result.data.localId }
      payload: { token:result.credential.accessToken, localId: result.user.uid }
  });
    })
      .catch(error => {
        if (error.code === ERROR_CODE_ACCOUNT_EXISTS) {
          error.message = ERROR_MSG_ACCOUNT_EXISTS;
        }

        this.setState({ error });
      });
  };
  render() {
    const { error } = this.state;
    return (
      <Consumer>
        {
          value => {
            const { dispatch } = value;
            return (
              <form onSubmit={this.onSubmit.bind(this, dispatch)} className="inline">

        <Button color="twitter" type="submit">
          <Icon name="twitter" /> 
        </Button>

                {error && (
                  <Message negative>
                    <p>{error.message}</p>
                  </Message>
                )}
              </form>
            )
          }
        }
      </Consumer>
    )
  }
}

const ERROR_CODE_ACCOUNT_EXISTS =
  'auth/account-exists-with-different-credential';

const ERROR_MSG_ACCOUNT_EXISTS = `
  An account with an E-Mail address to
  this social account already exists. Try to login from
  this account instead and associate your social accounts on
  your personal account page.
`;

// export default SignInGoogleBase
SignInTwitterBase.contextType = MyContext;
export default SignInTwitterBase
